import { getOptions, logger, VerificationStep } from '@sheerid/jslib';
import { QUERY_STRING_PREV_STEP_OVERRIDE } from '../../constants';

export const getPreviousStepOverride = (): VerificationStep | undefined => {
    try {
        const parsed: URLSearchParams = new URLSearchParams(window.location.search);

        if (parsed.get(QUERY_STRING_PREV_STEP_OVERRIDE)) {
            return parsed.get(QUERY_STRING_PREV_STEP_OVERRIDE) as VerificationStep;
        }
        // @ts-ignore
        if (getOptions()[QUERY_STRING_PREV_STEP_OVERRIDE]) {
            // @ts-ignore
            return getOptions()[QUERY_STRING_PREV_STEP_OVERRIDE];
        }
    } catch (e) {
        logger.error(e, QUERY_STRING_PREV_STEP_OVERRIDE);
    }
};
